import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ChatAppConstants } from '../chat-app.constants';

/** Event kinds `POST /api/chat/telemetry` accepts. */
export type ChatAppTelemetryType = 'INSTALL' | 'PUSH_ACTIVATION';

/**
 * First-party adoption signals — SPEC-2026-09-internal-chat-pwa (T-39 · RNF-07). Two
 * events only: the app was installed (once per device), and a notification was activated
 * (with whether the intended conversation actually opened). Best effort: a lost event
 * never disturbs the user.
 */
@Injectable({ providedIn: 'root' })
export class ChatAppTelemetryService {

  constructor(private readonly http: HttpClient) { }

  /** Reports the install once per device; later launches do not count again. */
  reportInstall(): void {
    try {
      if (localStorage.getItem(ChatAppConstants.installReported)) return;
      localStorage.setItem(ChatAppConstants.installReported, new Date().toISOString());
    } catch {
      return;
    }
    this.post('INSTALL');
  }

  reportPushActivation(openedIntendedConversation: boolean): void {
    this.post('PUSH_ACTIVATION', openedIntendedConversation);
  }

  private post(type: ChatAppTelemetryType, openedIntendedConversation?: boolean): void {
    this.http.post('/chat/telemetry', {
      type,
      ...(openedIntendedConversation === undefined ? {} : { openedIntendedConversation }),
    }).subscribe({ error: () => { /* best effort */ } });
  }
}
